export const isDev = (): boolean => !['production', 'e2e', 'staging'].includes(process.env.REACT_APP_BUILD_ENV ?? '');
